<div id="page" class="page">
   <!-- ***site header html start*** -->
            <!-- ***site header html start*** -->
            <header id="masthead" class="site-header">
               <!-- header html start -->
               <div class="top-header">
                  <div class="container">
                     <div class="top-header-inner">
                        <div class="header-contact text-left">
                           <a href="tel:+01977259912">
                              <i aria-hidden="true" class="icon icon-phone-call2"></i>
                              <div class="header-contact-details">
                                 <span class="contact-label">Para contacto vía telefónico :</span>
                                 <h5 class="header-contact-no">+(506) 8868 4846</h5>
                              </div>
                           </a>
                        </div>
                        <div class="site-logo text-center">
                           <p class="site-title">
                             <!--  <a href="index.html">
                                 <img src="assets/images/site-logo.png" alt="Logo">
                              </a> -->
                           </p>
                        </div>
                        <div class="header-icon text-right">
                           <!-- <div class="header-search-icon d-inline-block">
                              <a href="javascript: void(0)" [matMenuTriggerFor]="shopping">
                                 <i aria-hidden="true" class="fas fa-shopping-cart"></i>
                              </a>
                           </div> -->
                        </div>
                     </div>
                  </div>
               </div>

               <mat-menu #shopping="matMenu">
                  <button mat-menu-item *ngFor="let item of getShoppingCart()">
                     <span class="myrow">{{item.product}} -  ${{item.price}}</span>
                  </button>
                  <button mat-menu-item>
                     <span class="myrow">Pagar</span>
                  </button>
               </mat-menu>

               <mat-menu #social="matMenu">
                  <button mat-menu-item><span class="myrow"><i class="fab fa-facebook-f" aria-hidden="true"></i>VoyJaleas</span></button>
                  <button mat-menu-item><span class="myrow"><i class="fab fa-instagram" aria-hidden="true"></i>@voyjaleas</span></button>
                  <button mat-menu-item><span class="myrow"><i class="fab fa-youtube" aria-hidden="true"></i>VoyJaleas</span></button>
                  <button mat-menu-item><span class="myrow"><i class="fab fa-whatsapp" aria-hidden="true"></i>(+34) 602 52 31 56</span></button>
               </mat-menu>

               <div class="bottom-header">
                  <div class="container">
                     <div class="bottom-header-inner d-flex justify-content-between align-items-center">
                        <div class="header-social social-icon">
                           <ul>
                              <li>
                                 <a href="javascript: void(0)" [matMenuTriggerFor]="social">
                                    <i class="fab fa-facebook-f" aria-hidden="true"></i>
                                 </a>
                              </li>
                              <li>
                                 <a href="javascript: void(0)"[matMenuTriggerFor]="social">
                                    <i class="fab fa-instagram" aria-hidden="true"></i>
                                 </a>
                              </li>
                              <li>
                                 <a href="javascript: void(0)" [matMenuTriggerFor]="social">
                                    <i class="fab fa-youtube" aria-hidden="true"></i>
                                 </a>
                              </li>
                              <li>
                                 <a href="javascript: void(0)" [matMenuTriggerFor]="social">
                                    <i class="fab fa-whatsapp" aria-hidden="true"></i>
                                 </a>
                              </li>
                           </ul>
                        </div>
                        <div class="navigation-container d-none d-lg-block">
                           <nav id="navigation" class="navigation">
                              <ul>
                                 <li class="menu-item-has-children">
                                    <a href="team">Nosotros</a>
                                    <ul>
                                       <li>
                                          <a href="javascript: void(0)" (click)="scrollToElement('ourteam')">Sebastián Jiménez</a>
                                       </li>

                                       <li>
                                          <a href="javascript: void(0)" (click)="scrollToElement('ourteam')">Felipe Hidalgo</a>
                                       </li>
                                    </ul>
                                 </li>
                                 <li class="menu-item-has-children">
                                    <a href="javascript: void(0)">Para vos</a>
                                    <ul>
                                       <li>
                                          <a href="javascript: void(0)" (click)="scrollToElement('budget')">Cotización</a>
                                       </li>
                                       <li>
                                          <a href="javascript: void(0)" (click)="scrollToElement('packsoffer')">Oferta de paquetes</a>
                                       </li>
                                       <li>
                                          <a href="javascript: void(0)" (click)="scrollToElement('other')">Otros servicios</a>
                                       </li>
                                    </ul>
                                 </li>
                                 
                                 <li>
                                    <a href="https://www.instagram.com/voyjaleas/" target="_blank">Contactar</a>
                                 </li>
                              </ul>
                           </nav>
                        </div>
                        <div class="header-btn">
                           <a href="javascript: void(0)" (click)="scrollToElement('budget')" class="round-btn">Cotización</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="mobile-menu-container"></div>
            </header>

   <!-- ***site header html end*** -->
   <main id="content" class="site-main">
      <section class="inner-page-wrap">
         <!-- ***Inner Banner html start form here*** -->
         <div class="inner-banner-wrap">
            <div [class]="getBannerCss()"> 
               <div class="container"> 
                  <div class="inner-banner-content">
                     <h4 style="color: #efefef;">{{getClientData().name }} {{getClientData().lastname}}</h4>
                     <h1 class="page-title">VoyJaleas <span *ngIf="getClientData().destination && getClientData().destination != 'No definida'"> para </span> <span *ngIf="getClientData().destination && getClientData().destination != 'No definida'"> {{getClientData().destination}}</span></h1>
                     <h6 *ngIf="getClientData().goal" style="color: #efefef;">{{getClientData().goal}}</h6>
                     <p *ngIf="getDateFrom()">{{getDateFrom()}}</p>
                  </div>
               </div>
            </div>
         </div>
         <!-- ***Inner Banner html end here*** -->

         <div #budget></div>
         <div class="container">
            <div class="row">
               <div class="col-lg-8 offset-lg-2 text-sm-center">
                  <div class="section-heading">
                     <h5 class="sub-title">Preparamos para vos la siguiente</h5>
                     <h2 class="section-title">Cotización de servicios</h2>
                     <p>Gracias por confiar en nuestros servicios. 

                        Tal y como comentamos en la videollamada, te presentamos la cotización según el análisis que hemos realizado de tu caso.</p>
                  </div>
               </div>
            </div>

            <!-- Photo by <a href="https://unsplash.com/@shotinraww?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">shotinraww</a> on <a href="https://unsplash.com/photos/man-sitting-on-top-of-bridge-gYezIhYbwzI?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
  
            <!-- Premium
               Photo by <a href="https://unsplash.com/@martenbjork?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Marten Bjork</a> on <a href="https://unsplash.com/photos/person-typing-on-silver-laptop-computer-ANGrwTKxjlk?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
  
            Photo by <a href="https://unsplash.com/@windows?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Windows</a> on <a href="https://unsplash.com/photos/3-women-sitting-on-chair-hNiNxhUfCfQ?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
   -->

   <!-- Full
   Photo by <a href="https://unsplash.com/@anniespratt?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Annie Spratt</a> on <a href="https://unsplash.com/photos/men-sitting-in-front-of-their-laptop-computer-MChSQHxGZrQ?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
   -->
            <app-locked-modal *ngIf="isLocked()"></app-locked-modal>
            <div class="destination-section" *ngIf="!isLocked()">
               <div class="row">
                  <div class="col-lg-4 col-md-6" *ngFor="let pack of packages">
                     <article [class]="getCssClass(pack)">
                        <div class="destination-content">
                           <div class="rating-start-wrap">
                              
                              <div class="my-icon">
                                 <i [class]="pack.icon"></i>
                              </div>
                           </div>
                           <span class="cat-link">
                              <a href="destination.html">{{pack.shortPrhase}}</a>
                           </span>
                           <h3>
                              <a href="package-detail.html">{{pack.name}}</a>
                           </h3>
                           <p>{{pack.description}}</p>
                        </div>
                     </article>
                  </div>
                  
               </div>
               <div class="section-btn-wrap text-center">
                  <a href="javascript: void(0)" class="round-btn">Paquetes de servicios</a>
               </div>
            </div>
         </div>

         <div #packsoffer></div>
         <app-pricing-plans *ngIf="!isLocked() && getClientPackages().length>0" [packages]="getClientPackages()"></app-pricing-plans>

         <app-package-details [package]="getCurrentPack()" *ngIf="getCurrentPack() && !isLocked()"></app-package-details>

         <!-- ***offer package section html start form here*** -->
         <div class="offer-package-wrap" *ngIf="!isLocked()">
            <div class="container">
               <div class="row gx-5">
              
                <!--  VIDEOCALL
                 Photo by <a href="https://unsplash.com/@nate_dumlao?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Nathan Dumlao</a> on <a href="https://unsplash.com/photos/macbook-pro-on-brown-leather-couch-9dYwCScW0Rs?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
   -->

   <!-- UNIVERSITY
   Photo by <a href="https://unsplash.com/@rutmiit?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">RUT MIIT</a> on <a href="https://unsplash.com/photos/person-holding-black-academic-hat-oTglG1D4hRA?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
   -->

   <!-- ACCOMMO
   Photo by <a href="https://unsplash.com/@jackgisel?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Jack Gisel</a> on <a href="https://unsplash.com/photos/aerial-photo-of-city-during-daytime-tHhqErhxVMA?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
   -->
               <div #other></div>
                  <div class="col-md-6"  *ngFor="let product of otherProducts">
                     <article [class]="getCssClassImage(product)">
                        <!-- <div class="offer-badge">
                           {{product.discount}}% descuento
                        </div> -->
                        <div class="offer-content">
                           <!-- <div class="package-meta">
                              <ul>
                                 <li>
                                    <i class="fas fa-clock"></i>
                                    5D/4N
                                 </li>
                                 <li>
                                    <i class="fas fa-user-friends"></i>
                                    pax: 10
                                 </li>
                                 <li>
                                    <i class="fas fa-map-marker-alt"></i>
                                    Malaysia
                                 </li>
                              </ul>
                           </div> -->
                           <h3>
                              <a href="package.html">{{product.product}}</a>
                           </h3>
                           <p>{{product.description}}</p>
                           <div class="price-list">
                              price: 
                              <del *ngIf="product.oldPrice">${{product.oldPrice}} </del>
                              <ins>${{product.price}}</ins>
                           </div>
                           <!-- <a href="javascript: void(0)" (click)="bookNow(product)" class="round-btn">{{product.actionButton}}</a> -->
                        </div>
                     </article>
                  </div>
               </div>
            </div>
         </div>
         <!-- ***offer package section html start form here*** -->
         <div #ourteam></div>
         <app-our-team></app-our-team>
         
         <!-- BANNER VIDEO -->
         <div class="bg-img-fullcallback" style="background-image: url(https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/3b6bee26-cf29-4379-575c-0af8c0687d00/public);">
            <div class="overlay"></div>
            <div class="container">
               <div class="row">
                  <div class="col-lg-8 offset-lg-2 text-center">
                     <div class="callback-content">
                        <div class="video-button">
                           <a  id="video-container" data-fancybox="video-gallery" href="https://youtu.be/Una5pHNy_kQU">
                              <i class="fas fa-play"></i>
                           </a>
                        </div>
                        <h2 class="section-title">somos aventureros
                           persiguiendo
                           sueños y
                           cumpliendo
                           metas</h2>
                        <h4>
                           
                           además, lo
                           hacemos de
                           puta madre!</h4>
                        <!-- <div class="callback-btn">
                           <a href="package.html" class="round-btn">View Packages</a>
                           <a href="about.html" class="outline-btn outline-btn-white">Learn More</a>
                        </div> -->
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <!-- ***callback section html end here*** -->
      </section>
   </main>
   <!-- ***site footer html start form here*** -->
   <footer id="colophon" class="site-footer footer-primary">
      <div class="top-footer">
         
      </div>
      <div class="bottom-footer">
         <div class="container">
            <div class="copy-right text-center">Copyright &copy; 2024 VoyJaleas. Todos los derechos reservados.</div>
         </div>
      </div>
   </footer>
   <!-- ***site footer html end*** -->
   <a id="backTotop" href="#" class="to-top-icon">
      <i class="fas fa-chevron-up"></i>
   </a>

   <!-- ***custom top bar offcanvas html*** -->
</div>